import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";

export function TableToolbar() {
  return (
    <GridToolbarContainer sx={{ justifyContent: "space-between" }}>
      <GridToolbarColumnsButton />
    </GridToolbarContainer>
  );
}
